import Jszip from 'jszip'
import axios from 'axios'

const zip = {
  //文件解压缩 异步操作
  async unzipFile(file) {
    if (!file || file.type !== 'application/zip') {
      return
    }
    const zipData = new Jszip()
    const newFiles = []
    await zipData.loadAsync(file).then(async zip => {
      const files = zip.files
      for (let f in files) {
        let zipobj = files[f]
        if (!zipobj.dir) {
          const fileName = zipobj.name.split('/')[
            zipobj.name.split('/').length - 1
          ]
          if (fileName.slice(0, 1) !== '.') {
            await zipData
              .file(f)
              .async('blob')
              .then(blob => {
                const file = new window.File([blob], zipobj.name)
                newFiles.push(file)
              })
          }
        }
      }
    })
    return newFiles
  },
  async zipFile(files, filename) {
    const zipData = new Jszip()
    const arr = []
    files.forEach(async (item, index) => {
      if (item.file) {
        zipData.file(item.name, item.file)
      } else {
        arr[index] = axios({
          url: item.downloadUrl,
          method: 'get',
          responseType: 'blob'
        })
      }
    })
    if (arr && arr.length) {
      const reses = await Promise.all(arr)
      reses.forEach((item, index) => {
        zipData.file(files[index].name, item.data)
      })
    }
    const content = await zipData.generateAsync({ type: 'blob' })
    // content就是blob数据，这里以filename.zip名称下载
    const file = new File([content], filename + '.zip', {
      type: 'application/zip'
    })
    return file
  }
}

export default zip
